const containsOne = ({ selectedFilters, currentListing }) => {
  // Current listings can be an array or object.
  if (Array.isArray(currentListing)) {
    const hasResults = currentListing.filter((tags) => {
      // Will return true or false depending on if the selected
      // filter uuid is available and if it's true.
      return selectedFilters.indexOf(tags.drupal_id) !== -1 ? true : false;
    });

    // If no filters match the content item this array
    // will be empty and return false.
    return hasResults.length > 0;
  }
  else {
    return selectedFilters.indexOf(currentListing.drupal_id) !== -1 ? true : false;
  }
};

// Takes listings, selected filters and returns any results that match
// OR returns all results because the field didn't exist.
const listingFilter = ({ listings, selectedFilters, field }) => {
  return listings.filter((listing) => {
    // Check to see if there is any content within this field.
    const fieldTags = listing.node.relationships[field]
      ? listing.node.relationships[field]
      : null;

    // If there are NO tags but filters are selected, remove those items.
    if (!fieldTags && selectedFilters.length > 0) {
      return false;
    }

    // If there are no tags OR no filters for this field are selected,
    // return all listings.
    if (!fieldTags || selectedFilters.length === 0) {
      return true;
    }

    // If there IS content within the field, check it against the matches.
    return containsOne({
      selectedFilters: selectedFilters,
      currentListing: fieldTags
    });
  });
};

// Purges listings that have NO tags, series or venue.
const removeEmptyListings = ({ listings, fields }) => {
  return listings.filter((listing) => {
    let hasPopulatedFields = false;

    // Check to see if there is any content within the fields.
    for (let i = 0; i < fields.length; i++) {
      if (listing.node.relationships[fields[i]]) {
        hasPopulatedFields = true;
        break;
      }
    }

    return hasPopulatedFields;
  });
};

export { listingFilter, containsOne, removeEmptyListings };
